type dropdownProps = {
  toggleSelector?: string
  menuSelector?: string
  chevronSelector?: string
}

export default function dropdown(el: HTMLElement, props: dropdownProps) {
  // Use default selectors if none provided
  const toggleSelector = props.toggleSelector || ".dropdown-toggle"
  const chevronSelector = props.chevronSelector || ".dropdown-toggle-chevron"
  const menuSelector = props.menuSelector || ".dropdown-menu"

  const toggleElement = el.querySelector(toggleSelector)
  const chevronElement = el.querySelector(chevronSelector)
  const menuElement = el.querySelector(menuSelector)

  let menuIsOpen = false

  if (!toggleElement || !menuElement) {
    return
  }

  function toggleMenu() {
    if (menuIsOpen) {
      closeMenu()
    } else {
      openMenu()
    }
  }

  function openMenu() {
    menuElement?.classList.remove("hidden")
    toggleElement?.setAttribute("data-toggle", "open")
    toggleElement?.setAttribute("aria-expanded", "true")
    chevronElement?.classList.add("rotate-180")
    menuIsOpen = true
  }

  function closeMenu() {
    menuElement?.classList.add("hidden")
    toggleElement?.setAttribute("data-toggle", "closed")
    toggleElement?.setAttribute("aria-expanded", "false")
    chevronElement?.classList.remove("rotate-180")
    menuIsOpen = false
  }

  function handleToggleClick(e: Event) {
    e.preventDefault()
    toggleMenu()
  }

  function handleOutsideClick(e: Event) {
    if (!el.contains(e.target as HTMLElement)) {
      if (menuIsOpen) {
        closeMenu()
      }
    }
  }

  toggleElement.addEventListener("click", handleToggleClick)
  document.addEventListener("click", handleOutsideClick)
}
